export const correoPlantillaNormalize = (source) => {
    return {
        idCorreoPlantilla: source.idCorreoPlantilla ?? source.IdCorreoPlantilla ?? 0,
        asuntoCorreo: source.asuntoCorreo ?? source.AsuntoCorreo ?? '',
        contenidoCorreo: source.contenidoCorreo ?? source.ContenidoCorreo ?? '',
        momento: source.momento ?? source.Momento ?? '',
        enviar: source.enviar ?? source.Enviar ?? false,
        activo: source.activo ?? source.Activo ?? false,
        programarEnvio: source.programarEnvio ?? source.ProgramarEnvio ?? false,
        diaEnvio: source.diaEnvio ?? source.DiaEnvio ?? null,
        horaEnvio: source.horaEnvio ?? source.HoraEnvio ?? null,
        ultimoEnvio: source.ultimoEnvio ?? source.UltimoEnvio ?? null,
        enviarReporteLms: source.enviarReporteLms ?? source.EnviarReporteLms ?? false
    }
}
